require('./Resources/js/angular/module');
require('./Resources/js/angular/controllers/TrackNoteCtrl');
require('./Resources/js/angular/controllers/SelectTrackModalCtrl');
require('./Resources/js/angular/controllers/BaseSelectModalCtrl');
require('./Resources/js/angular/services/Keyword');
require('./Resources/js/angular/services/KeywordType');
require('./Resources/js/angular/services/Tag');
require('./Resources/js/angular/services/TrackNote');
require('./Resources/js/angular/services/Track');
require('./Resources/js/angular/services/TrackNoteFormModal');
require('./Resources/js/angular/services/SelectTrackModal');


// WEBPACK FOOTER //
// ./vendor/sonyatv/smfcoreclientbundle/index.js